/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateExerciseWeightDto } from './create-exercise-weight-dto';
import { EnExerciseType } from './en-exercise-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateSessionExerciseDto
 */
export interface CreateSessionExerciseDto {

    /**
     * Rest between sets
     *
     * @type {number}
     * @memberof CreateSessionExerciseDto
     */
    rest: number;

    /**
     * Number of exercise repetitions
     *
     * @type {number}
     * @memberof CreateSessionExerciseDto
     */
    reps: number;

    /**
     * Number of set (each set include repetitions)
     *
     * @type {number}
     * @memberof CreateSessionExerciseDto
     */
    sets: number;

    /**
     * @type {EnExerciseType}
     * @memberof CreateSessionExerciseDto
     */
    type: EnExerciseType;

    /**
     * Progressive number of exercise into the session
     *
     * @type {number}
     * @memberof CreateSessionExerciseDto
     */
    sequence: number;

    /**
     * Playback speed of the linked exercise
     *
     * @type {number}
     * @memberof CreateSessionExerciseDto
     */
    speed?: number;

    /**
     * @type {string}
     * @memberof CreateSessionExerciseDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateSessionExerciseDto
     */
    exercise: JoinEntityDto;

    /**
     * Session-level weight overrides per body part (tier 3)
     *
     * @type {Array<CreateExerciseWeightDto>}
     * @memberof CreateSessionExerciseDto
     */
    weights?: Array<CreateExerciseWeightDto>;
}
